module.exports = __webpack_public_path__ + "static/media/C.a0a94658.png";